import Design from "./design";
import Pattern from "./pattern";
import Point from "./point";
import Path from "./path";
import Snippet from "./snippet";
import * as utils from "./utils";
import { version } from "../package.json";

export default {
  version,
  Design,
  Pattern,
  Point,
  Path,
  Snippet,
  utils,
  patterns: {},
  plugins: {}
};
